
import StatLine from '../StatLine'

export default {
  components: {
    StatLine,
  },
  props: {
    stats: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getInterval(range) {
      const intervals = {
        between_4_and_5: '4-5',
        between_3_and_4: '3-4',
        between_2_and_3: '2-3',
        between_1_and_2: '1-2',
      }

      return intervals[range]
    },
  },
}
